// extracted by mini-css-extract-plugin
export default {"wrapper":"toggleButton_wrapper__dXWrq","toggle":"toggleButton_toggle__xk4qY","label":"toggleButton_label__sKm6P"};